import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ErrorBoundary } from 'bernie-view';

import { MesoTrigger } from 'components/meso/meso-trigger';

interface MesoNativeResultListingProps {
  uci: string;
  className: string;
  errorBoundaryLabel?: string;
}

interface MesoNativeResultListingState {
  adServed: boolean;
}

export class MesoNativeResultListing extends React.Component<MesoNativeResultListingProps, MesoNativeResultListingState> {
  private adRef;

  public static defaultProps = {
    errorBoundaryLabel: 'hotel.meso'
  };

  constructor(props) {
    super(props);
    this.state = {
      adServed: false
    };
    this.adRef = React.createRef();
  }

  public componentDidMount() {
    // Attach the event listener for the ad request.
    const node = this.adRef.current;

    if (node) {
      node.addEventListener('mesoAd', e => {
        if (e && e.detail) {
          if (e.detail.code === 'AD-LOAD-PASS') {
            this.setState({
              adServed: true
            });
          }
          if (e.detail.code === 'AD-LOAD-FAIL') {
            this.setState({
              adServed: false
            });
          }
        }
      });
    }
  }

  public render() {
    const { errorBoundaryLabel, uci, className } = this.props;

    return (
      <ErrorBoundary label={errorBoundaryLabel}>
        <li data-stid="native-results-listing" className={this.state.adServed ? className : ''}>
          <AbacusExperiment name="PWA_MESO_NRL_Test">
            <AbacusControl>
              <meso-native-results-listing ref={this.adRef} uci={uci} />
            </AbacusControl>
            <AbacusVariant bucket={1}>
              <meso-native-results-listing ref={this.adRef} uci={uci + '1'} />
            </AbacusVariant>
            <AbacusVariant bucket={2}>
              <meso-native-results-listing ref={this.adRef} uci={uci + '2'} />
            </AbacusVariant>
            <AbacusVariant bucket={3}>
              <meso-native-results-listing ref={this.adRef} uci={uci} />
            </AbacusVariant>
          </AbacusExperiment>
        </li>
        <MesoTrigger pageName="page.Hotels.Search" />
      </ErrorBoundary>
    );
  }
}
